import { useEffect, useRef, useState } from 'react'

import { postRemountEmbeddedChatMessage } from '~/features/chatbot/utils'
import useIsPartner from '~/features/partners/hooks/useIsPartner/v2'
import EEnvironmentVariables from '~/models/config'
import { store } from '~/store'

const useRemountEmbeddedChatOnUserIdChange = () => {
  const userId = store((state) => state.user.id)
  const previousUserIdRef = useRef<string | undefined>(undefined)
  const isPartner = useIsPartner()
  const [hasStoreHydrated, setHasStoreHydrated] = useState(() =>
    store.persist.hasHydrated(),
  )

  useEffect(() => {
    if (store.persist.hasHydrated()) {
      setHasStoreHydrated(true)
    }

    const unsubscribeFinishHydration = store.persist.onFinishHydration(() => {
      setHasStoreHydrated(true)
    })

    return unsubscribeFinishHydration
  }, [])

  useEffect(() => {
    if (!hasStoreHydrated) {
      return
    }

    if (previousUserIdRef.current === userId) {
      return
    }

    const isUserIdChange = previousUserIdRef.current !== undefined
    previousUserIdRef.current = userId

    if (!isUserIdChange) {
      return
    }

    const updateAgentId = () => {
      if (isPartner) return

      const supportAgentId = import.meta.env[
        EEnvironmentVariables.VITE_CHATBOT_AGENT_ID
      ]
      const marketingAgentId =
        import.meta.env[
          EEnvironmentVariables.VITE_CHATBOT_MARKETING_AGENT_ID
        ] || supportAgentId

      type TWindow = Window & { agentId?: string }
      ;(window as TWindow).agentId = userId ? supportAgentId : marketingAgentId
    }

    updateAgentId()
    postRemountEmbeddedChatMessage()
  }, [hasStoreHydrated, isPartner, userId])
}

export default useRemountEmbeddedChatOnUserIdChange
